import { Appear } from "@features/motion/Appear"
import { cn } from "@utils/tw"
import { EditableText } from "eddev/blocks"
import { ReactNode } from "react"

type Props = {
  content: ReactNode
  attribution: ReactNode
}

export function QuoteCard(props: Props) {
  return (
    <Appear className={cn("quote-card w-full block-spacing text-blue flex flex-col gap-6 relative")}>
      <div className={cn("w-full shrink-0 p-7 bg-white text-blue text-center")}>
        <div className="w-full h-full border border-blue absolute left-[6.4px] top-[6.4px] pointer-events-none bg-white" />
        <div className="w-full h-full border border-blue absolute left-0 top-0 pointer-events-none bg-white" />

        <div className="w-full h-full flex items-center justify-center flex-col gap-4 relative">
          <div className="type-body-l leading-tight text-left w-full">{props.content}</div>
          {props.attribution && (
            <div className="type-title-xxs flex flex-nowrap items-center justify-center">
              <div className="w-7 h-[1px] mr-[1.8em] bg-blue" />
              <p className="text-[0.8em] shrink-0">{props.attribution}</p>
              <div className="w-7 h-[1px] ml-[1.8em] bg-blue" />
            </div>
          )}
        </div>
      </div>
    </Appear>
  )
}
